import styled from 'styled-components';

import { media } from '~src/styles/media-templates';

export const InfoSortingBlock = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SurveysContainer = styled.section`
  margin-top: 30px;
`;

export const FilterSortCol = styled.div`
  display: flex;
  justify-content: flex-end;
  ${media.phone`
    min-width: 100%;
  `}
`;

export const StatusFilterWrapper = styled.div`
  max-width: 185px;
  padding: 0 20px;
  float: left;
`;

export const SortSelectorWrapper = styled.div`
  padding: 0 0 0 20px;
  min-width: 185px;
  float: right;
`;

export const ListWrapper = styled.div`
  min-height: 110px;
  padding-top: 1px;
`;

export const NoSurveysTxt = styled.div`
  text-align: center;
  font-size: 1rem;
  color: ${({ theme }) => theme.baseBlue.a6};
  margin-top: 60px;
`;

export const ResetFiltersBtn = styled.button`
  border: 0;
  background: none;
  cursor: pointer;
  text-decoration: underline;
  margin-top: 5px;
  outline: none;
`;
